import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import styled from '../../../libs/styled.es.js';
import { resolveTekoPathname, getUrlObject } from '@teko/utils';

const Anchor = styled.a`
  color: unset;
  text-decoration: unset;
`;
const CustomLink = ({
  targetPath,
  children,
  targetType = "_self"
}) => {
  const [href, setHref] = useState({
    pathname: targetPath,
    query: {}
  });
  useEffect(() => {
    const init = async () => {
      if (!targetPath)
        return;
      const { pathname, query } = await resolveTekoPathname(getUrlObject(targetPath));
      setHref({
        pathname: pathname || targetPath,
        query
      });
    };
    init();
  }, [targetPath]);
  if (!targetPath)
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  if (targetPath.startsWith("http"))
    return /* @__PURE__ */ React.createElement(Anchor, {
      target: targetType,
      href: targetPath
    }, children);
  return /* @__PURE__ */ React.createElement(Link, {
    href,
    as: targetPath,
    passHref: true,
    legacyBehavior: true
  }, /* @__PURE__ */ React.createElement(Anchor, {
    target: targetType
  }, children));
};

export { CustomLink };
